const AADHAAR_ENCRYPTION_ALGORITHM = "AES-GCM";
const AADHAAR_IV_LENGTH = 12;
const AADHAAR_SHARED_SECRET = process.env.REACT_APP_AADHAAR_AES_KEY || "";

const textEncoder = new TextEncoder();

function bytesToBase64(bytes) {
  return btoa(String.fromCharCode(...bytes));
}

async function getAadhaarEncryptionKey() {
  const normalizedSecret = String(AADHAAR_SHARED_SECRET || "").trim();

  if (!normalizedSecret) {
    throw new Error("REACT_APP_AADHAAR_AES_KEY is not configured.");
  }

  const secretBytes = textEncoder.encode(normalizedSecret);
  const derivedKeyBuffer = await crypto.subtle.digest("SHA-256", secretBytes);

  return crypto.subtle.importKey(
    "raw",
    derivedKeyBuffer,
    { name: AADHAAR_ENCRYPTION_ALGORITHM },
    false,
    ["encrypt"]
  );
}

export async function encryptAadhaarNumber(aadhaarNumber) {
  const normalizedAadhaarNumber = String(aadhaarNumber || "").trim();

  if (!normalizedAadhaarNumber) {
    throw new Error("Aadhaar number is required for encryption.");
  }

  const encryptionKey = await getAadhaarEncryptionKey();
  const iv = crypto.getRandomValues(new Uint8Array(AADHAAR_IV_LENGTH));
  const encryptedBuffer = await crypto.subtle.encrypt(
    {
      name: AADHAAR_ENCRYPTION_ALGORITHM,
      iv,
    },
    encryptionKey,
    textEncoder.encode(normalizedAadhaarNumber)
  );

  return {
    aadhaarNumber: bytesToBase64(new Uint8Array(encryptedBuffer)),
    aadhaarIv: bytesToBase64(iv),
    // aadhaarEncryption: AADHAAR_ENCRYPTION_ALGORITHM,
  };
}
